import { Controller } from "@hotwired/stimulus"

// The deck download form (operator/deck_pdfs/new) submits without Turbo: its answer is the PDF
// file, so the page stays where it is. Once the browser has sent it, close the modal around it.
export default class extends Controller {
  submit() {
    setTimeout(() => this.element.closest("[data-controller~='modal']")?.remove(), 300)
  }
}
